import { gsap } from "gsap";  

export class Marquee { 
  constructor(items, config) {
    this.items = gsap.utils.toArray(items);
    this.config = config || {};
    this.tl = gsap.timeline({ repeat: config.repeat, paused: config.paused, defaults: { ease: "none" }, onReverseComplete: () => this.tl.totalTime(this.tl.rawTime() + this.tl.duration() * 100) });
    this.length = this.items.length;
    this.startX = this.items[0].offsetLeft;
    this.times = [];
    this.widths = []; 
    this.xPercents = [];
    this.curIndex = 0;
    this.pixelsPerSecond = (config.speed || 1) * 100;
    this.snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1);
    this.totalWidth = 0;
    this.curX = 0;
    this.distanceToStart = 0;
    this.distanceToLoop = 0;
    this.item = null;
    this.i = 0;

    gsap.set(this.items, {
      xPercent: (i, el) => {
        let w = this.widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
        this.xPercents[i] = this.snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
        return this.xPercents[i];
      }
    });

    gsap.set(this.items, { x: 0 });

    this.totalWidth = this.items[this.length - 1].offsetLeft + this.xPercents[this.length - 1] / 100 * this.widths[this.length - 1] - this.startX + this.items[this.length - 1].offsetWidth * gsap.getProperty(this.items[this.length - 1], "scaleX") + (parseFloat(this.config.paddingRight) || 0);

    for (this.i = 0; this.i < this.length; this.i++) {
      this.item = this.items[this.i];
      this.curX = this.xPercents[this.i] / 100 * this.widths[this.i];
      this.distanceToStart = this.item.offsetLeft + this.curX - this.startX;
      this.distanceToLoop = this.distanceToStart + this.widths[this.i] * gsap.getProperty(this.item, "scaleX");
      this.tl.to(this.item, { xPercent: this.snap((this.curX - this.distanceToLoop) / this.widths[this.i] * 100), duration: this.distanceToLoop / this.pixelsPerSecond }, 0)
        .fromTo(this.item, { xPercent: this.snap((this.curX - this.distanceToLoop + this.totalWidth) / this.widths[this.i] * 100) }, { xPercent: this.xPercents[this.i], duration: (this.curX - this.distanceToLoop + this.totalWidth - this.curX) / this.pixelsPerSecond, immediateRender: false }, this.distanceToLoop / this.pixelsPerSecond)
        .add("label" + this.i, this.distanceToStart / this.pixelsPerSecond);
      this.times[this.i] = this.distanceToStart / this.pixelsPerSecond;
    }

    this.tl.next = vars => this.toIndex(this.curIndex + 1, vars);
    this.tl.previous = vars => this.toIndex(this.curIndex - 1, vars);
    this.tl.current = () => this.curIndex;
    this.tl.toIndex = (index, vars) => this.toIndex(index, vars);
    this.tl.times = this.times;
    this.tl.progress(1, true).progress(0, true);

  }

  toIndex(index, vars) {
    vars = vars || {};
    (Math.abs(index - this.curIndex) > this.length / 2) && (index += index > this.curIndex ? -this.length : this.length);
    let newIndex = gsap.utils.wrap(0, this.length, index),
      time = this.times[newIndex];
    if (time > this.tl.time() !== index > this.curIndex) {
      vars.modifiers = { time: gsap.utils.wrap(0, this.tl.duration()) };
      time += this.tl.duration() * (index > this.curIndex ? 1 : -1);
    }
    this.curIndex = newIndex;
    vars.overwrite = true;
    return this.tl.tweenTo(time, vars);
  }

  play() {
    this.tl.play();
  }

  reverse() {
    this.tl.vars.onReverseComplete();
    this.tl.reverse();
  }

  pause() {
    this.tl.pause();
  }
}